<div class="common-heading" [ngStyle]="{ 'font-size': size+'px' }" [ngClass]="color">
    {{title}}
</div>